/**
 * The funnel's redraw count (pull to refresh, pageRefresh.ts): FunnelBoundary
 * keys its outlet on it, so a bump draws the routed page again and the page's
 * own first reads run once more. Kept free of other imports on purpose: App.tsx
 * loads FunnelBoundary on every page of the site.
 */
import { useSyncExternalStore } from 'react';

let epoch = 0;
const listeners = new Set<() => void>();

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** The redraw count; the server and the hydrating draw read 0. */
export function usePageEpoch(): number {
  return useSyncExternalStore(subscribe, () => epoch, () => 0);
}

/** Draw the routed page again (its mount reads run once more). */
export function redrawPage(): void {
  epoch += 1;
  for (const fn of [...listeners]) fn();
}
